import React, { Component } from "react";
import { TextField, Button, Paper } from "@material-ui/core";
import CKEditor from "react-ckeditor-component";
import { DeleteData, PostData } from "../../api/service";
import FileUpload from "../AddNew/FileUpload";


export default class RightPanel extends Component {
  state = {
    id: "",
    title: "",
    content_type: "",
    year: "",
    content_text: "",
    file_info: null,
    sequence: 0,
    parent_id: null,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected && this.props.selected) {
      const s = this.props.selected;
      this.setState({
        id: s.id,
        title: s.title,
        content_type: s.type,
        year: s.year,
        content_text: s.content_text,
        file_info: s.file_info,
        parent_id: s.parent_id,
        sequence: s.sequence || 0,
      });
    }
  }

  /** =====================================================
   *  FILE SETTER for <FileUpload />
   *  ===================================================== */
  onSetFile(fileJson) {
    this.setState({ file_info: fileJson });
  }

  /** =====================================================
   *  SAVE CONTENT
   *  ===================================================== */
  handleSave = () => {
    let payload = {
      title: this.state.title,
      content_type: this.state.content_type,
      year: this.state.year,
      content_text: this.state.content_text,
      file_info: this.state.file_info,
      parent_id: this.state.parent_id,
      sequence: this.state.sequence,
    };

    PostData(`/${this.props.apikey}/${this.state.id}/itep/update`, payload).then(() => {
      alert("Updated Successfully!");
      this.props.refresh(); // refresh tree
    });
  };

  /** =====================================================
   *  DELETE CONTENT
   *  ===================================================== */
  handleDelete = () => {
    if (!window.confirm("Are you sure you want to delete this item?")) {
      return;
    }

    DeleteData(`/${this.props.apikey}/${this.state.id}/itep/delete`)
      .then(() => {
        alert("Successfully deleted");
        this.props.refresh(); // refresh tree
        // this.props.onDeleteSelection(); // clear right panel
      });
  };

  render() {
    if (!this.props.selected) return <div>Select a section</div>;

    return (
      <Paper style={{ padding: 20 }}>
        <h3>Edit: {this.state.title}</h3>

        {/* TITLE */}
        <TextField
          label="Title"
          fullWidth
          value={this.state.title}
          onChange={(e) => this.setState({ title: e.target.value })}
          style={{ marginTop: 10 }}
        />

        {/* SEQUENCE */}
        <TextField
          label="Order"
          fullWidth
          value={this.state.sequence}
          onChange={(e) => this.setState({ sequence: e.target.value })}
          style={{ marginTop: 10 }}
        />

        {/* TEXT TYPE */}
        {this.state.content_type === "text" && (
          <div style={{ marginTop: 20 }}>
            <label style={{ fontWeight: "bold" }}>Content</label>
            <CKEditor
              content={this.state.content_text}
              events={{
                change: (evt) =>
                  this.setState({ content_text: evt.editor.getData() }),
              }}
            />
          </div>
        )}

        {/* FILE TYPE */}
        {this.state.content_type === "file" && (
          <div style={{ marginTop: 20 }}>
            <FileUpload
            key={this.state.id}    
              dp={this.state.file_info}
              apikey={this.props.apikey}
              type={`ITEP_FILES`}
              setDp={this.onSetFile.bind(this)}
            />

            {this.state.file_info && this.state.file_info.url && (
              <div style={{ marginTop: 10 }}>
                <a href={this.state.file_info.url} target="_blank">
                  {this.state.file_info.name}
                </a>
              </div>
            )}
          </div>
        )}

        {/* SECTION */}
        {this.state.content_type === "section" && (
          <p style={{ marginTop: 20, fontStyle: "italic" }}>
            This is a folder (category). Add children from the left panel.
          </p>
        )}

        {/* SAVE + DELETE BUTTONS */}
        <div style={{ marginTop: 25, display: "flex", gap: 10 }}>
          <Button variant="contained" color="primary" onClick={this.handleSave}>
            Save Changes
          </Button>

          <Button
            variant="contained"
            style={{ background: "#b71c1c", color: "#fff" }}
            onClick={this.handleDelete}
          >
            Delete
          </Button>
        </div>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/AdminITEP/RightPanel.js